import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import MenuItem from "@mui/material/MenuItem";

function LineHeight({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={"default"}>
          Default
        </MenuItem>,
        [0, 0.25, 0.5, 0.75, 0.8, 0.9, 1.0, 1.1, 1.2, 1.25, 1.5, 1.75, 2, 2.5, 3, 4, 5].map((lh) => {
          return (
            <MenuItem key={lh} value={`${lh}em`}>
              {lh} em
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSLineHeightComponent: JSInputComponent = {
  Component: LineHeight,
  handlesCssProperties: ["lineHeight"],
};
